import './App.css';
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
      
  <main>
    <Dictionary defaultKeyword="lisbon"/>
    </main>
    <footer> 
      This project was coded by Mariana Carvalho and is open sourced on <a href='https://github.com/MarianavCarvalho/dictionary-my-app-project'>GitHub</a>
    </footer>
      
      </div>
      </div>
    
  );
}
